export default "__VITE_ASSET__a23afd62__"